import { useEffect, useState } from 'react';
import SideNav from '../../../shared/components/SideNav';

import { getPAIAH010 } from '../../../services/Api';
import { useSelector } from 'react-redux';
import { decodeToken } from '../../../utils';

const PAIAH010 = ({ onAuthenticate }) => {
    const [plainPassword, setPlainPassword] = useState('');
    const token = useSelector(({ auth }) => auth.login.token);
    const [info, setInfo] = useState({});

    useEffect(() => {
        setInfo(decodeToken(token));
        // eslint-disable-next-line
    }, [token]);

    const handleInputChange = (e) => {
        const { value, name } = e.target;
        if (name === 'plainPassword') {
            setPlainPassword(value);
        }
    };

    const handleSave = async () => {
        const payload = {
            plainPassword,
        };

        if (plainPassword === '') {
            window.alert('비밀번호를 입력해 주세요.');
            return;
        }

        try {
            const response = await getPAIAH010(payload.plainPassword);
            if (response?.data === true) {
                onAuthenticate(true);
            } else if (response?.data === false) {
                window.alert('비밀번호가 일치하지 않습니다.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave();
    };

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">내 정보 수정</h3>
                            <div className="mdf">
                                <h4 className="mdf__tit">회원 정보 확인</h4>
                                <div className="mdf__block">
                                    <div className="mdf__top">
                                        회원님의 개인정보보호를 위해 비밀번호를 한번 더 입력해 주세요.
                                    </div>
                                    <div className="mdf__ipbx">
                                        <div className="mdf__grid">
                                            <span>아이디:</span>
                                            <span className="mdf__id">{info.memberID}</span>
                                            <span>비밀번호:</span>
                                            <input
                                                type="password"
                                                className="mdf__pswd"
                                                placeholder="비밀번호 입력"
                                                name="plainPassword"
                                                onChange={handleInputChange}
                                                onKeyDown={handleKeyDown}
                                            />
                                            <button type="button" className="mdf__confirm" onClick={handleSave}>
                                                확인
                                            </button>
                                        </div>
                                    </div>
                                    <p className="mdf__ps">
                                        ※ 개인정보는 외부에 유출되지 않도록 아이디 및 비밀번호 관리를 철저히 해 주시기
                                        바랍니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAIAH010;
